import React, { FC, useEffect, useState } from 'react';
import { NavigationProps, ApiException } from '@eta/components';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { verifyIntermediary } from '../Redux/Actions';
import { ContactTypes } from '../Service/proxy';
import { PublicLayout } from '../../common/layout/PublicLayout';
import './VerifyIntermediary.scss';

interface InvitationProps {
    taxpayerId: number;
    type: string;
    otp: string;
}

export const VerifyIntermediary: FC<NavigationProps<InvitationProps>> = (
    props: NavigationProps<InvitationProps>
) => {
    const { match } = props;
    const { taxpayerId, type, otp } = match.params;
    const { t } = useTranslation(['intermediaries']);
    const [verificationResult, setVerificationResult] = useState<boolean | undefined>(undefined);
    const [error, setError] = useState<string>();

    const verify = async () => {
        try {
            await verifyIntermediary(taxpayerId, otp, type === ContactTypes.Email ? ContactTypes.Email : ContactTypes.Mobile);
            setVerificationResult(true);
        } catch (ex) {
            setVerificationResult(false);
            const exp = ex as ApiException;
            setError(exp.serviceError?.toString());
        }
    };

    useEffect(() => {
        verify();
    }, [taxpayerId]);

    return (
        <PublicLayout>
            <div className='eta-panel'>
                <div className='verificationTitle'>{t(type)}</div>
                {
                    verificationResult !== undefined ? (
                        <div>
                            <div className='verificationMessage'>{verificationResult ? t('verificationSuccess').replace('contact', type.toLowerCase()) : (`${t('verificationFailed').replace('contact', type.toLowerCase())} ${error}`)}</div>
                            {verificationResult && (
                                <NavLink to="/TaxpayerProfile" className='goToProfile'>
                                    <div>{t('goToProfile')}</div>
                                </NavLink>
                            )}</div>
                    ) : (
                            <div className='verificationMessage'>{t('verifyig')}</div>
                        )
                }
            </div>
        </PublicLayout>
    );
};
